<template>
    <div class="container mt-8 flex flex-col items-center space-y-8">
        <h1 class="text-xl font-semibold">Apply your RSVPify Enterprise subscription to this account?</h1>

        <div class="flex items-center font-bold text-2xl space-x-8 text-center">
            <logo-rsvpify-full class="h-16 w-auto"></logo-rsvpify-full>
            <p>↔</p>
            <img
                class="h-20"
                :src="asset('images/vendor/aws/logo.svg')"
                title="AWS Logo"
            >
        </div>

        <p>The RSVPify Enterprise subscription that you purchased on AWS Marketplace will be applied to the RSVPify account associated with {{ auth().user().email }}.</p>

        <div class="flex space-x-4">
            <stateful-button
                class="button button-danger"
                :loading="cancelLoading"
                @click="cancel"
            >
                Cancel
            </stateful-button>

            <div
                v-tippy
                :content="buttonTooltip"
            >
                <stateful-button
                    class="button button-primary"
                    :disabled="alreadyExists"
                    :loading="loading"
                    @click="link"
                >
                    Apply Subscription
                </stateful-button>
            </div>

        </div>
    </div>
</template>

<script>
import axios from '@/util/axios';

export default {
    props: {
        alreadyExists: {
            type: Boolean,
            required: true
        },
        marketplaceId: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            cancelLoading: false,
            loading: false
        };
    },
    computed: {
        buttonTooltip () {
            return this.alreadyExists ? 'This AWS account is already linked to an RSVPify account. Please contact support to upgrade.' : null;
        }
    },
    methods: {
        cancel () {
            this.cancelLoading = true;

            axios.delete(this.route('aws.destroy'))
                .then(() => {
                    window.location.href = this.route('account.show');
                }).catch(() => {
                    App.alert().error('Failed to cancel AWS subscription.');
                }).finally(() => {
                    this.cancelLoading = false;
                });
        },
        link () {
            this.loading = true;

            axios.post(this.route('aws.store'), {
                marketplace_id: this.marketplaceId
            }).then(() => {
                App.alert().success(
                    '',
                    'We\'ve successfully applied your AWS subscription. You\'re all set!',
                    {
                        confirmButtonText: 'Continue'
                    }
                ).then(() => {
                    window.location.href = this.route('account.show');
                });
            }).catch(() => {
                App.alert().error('Failed to apply AWS subscription.');
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>
